import { ITask } from '../../../../types/tasks.types'
import Modal from '../../../../shared/Modal'
import ZeroTypeTaskDescription from '../TaskDescription/ZeroTypeTaskDescription'
import FirstTypeTaskDescription from '../TaskDescription/FirstTypeTaskDescription'
import SecondTypeTaskDescription from '../TaskDescription/SecondTypeTaskDescription'
import ThirdTypeTaskDescription from '../TaskDescription/ThirdTypeTaskDescription'
import FourthTypeTaskDescription from '../TaskDescription/FourthTypeTaskDescription'
import FifthTypeTaskDescription from '../TaskDescription/FifthTypeTaskDescription'
import SixthTypeTaskDescription from '../TaskDescription/SixthTypeTaskDescription'
import SeventhTypeTaskDescription from '../TaskDescription/SeventhTypeTaskDescription'
import EightsTypeTaskDescription from '../TaskDescription/EightsTypeTaskDescription'
import { ReactComponent as CloseIcon } from '../../../../asserts/icons/close-icon.svg'
import TenthTypeTaskDescription from '../TaskDescription/TenthTypeTaskDescription'
import EleventhTypeTaskDescription from '../TaskDescription/EleventhTypeTaskDescription'
import TwelfthTypeTaskDescription from '../TaskDescription/TwelfthTypeTaskDescription'
import FourteenthTaskTypeDescription from '../TaskDescription/FourteenthTaskTypeDescription'
import FifteenthTypeTaskDescription from '../TaskDescription/FifteenthTypeTaskDescription'
import ThirteenthTypeTaskDescription from '../TaskDescription/ThirteenthTypeTaskDescription'

interface IProps {
  type: ITask['type']
  onChange: (val: ITask['type']) => void
  onClose: () => void
}

const SelectTaskTypeModal = (props: IProps) => {
  return (
    <Modal onClose={props.onClose} size="hg">
      <div className="inline-flex-gap" style={{ marginBottom: '19px', width: '100%', justifyContent: 'space-between' }}>
        <h2 style={{ fontSize: '24px' }}>Выберите тип задания</h2>
        <div style={{ width: '32px', height: '32px', cursor: 'pointer' }} onClick={props.onClose}>
          <CloseIcon />
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '1em' }}>
        {Array.from(Array(16).keys()).map((taskType) =>
          taskType !== 8 ? (
            <div
              key={taskType}
              style={{
                width: '300px',
                padding: '16px',
                border: '1px solid var(--light-gray)',
                borderRadius: '8px',
                cursor: 'pointer',
                height: 'fit-content',
              }}
              onClick={() => props.onChange(taskType)}
            >
              {descriptions[taskType]}
            </div>
          ) : null
        )}
      </div>
    </Modal>
  )
}

const descriptions = {
  0: <ZeroTypeTaskDescription />,
  1: <FirstTypeTaskDescription />,
  2: <SecondTypeTaskDescription />,
  3: <ThirdTypeTaskDescription />,
  4: <FourthTypeTaskDescription />,
  5: <FifthTypeTaskDescription />,
  6: <SixthTypeTaskDescription />,
  7: <SeventhTypeTaskDescription />,
  9: <EightsTypeTaskDescription />,
  10: <TenthTypeTaskDescription />,
  11: <EleventhTypeTaskDescription />,
  12: <TwelfthTypeTaskDescription />,
  13: <ThirteenthTypeTaskDescription />,
  14: <FourteenthTaskTypeDescription />,
  15: <FifteenthTypeTaskDescription />,
}

export default SelectTaskTypeModal
